import { createSelector } from 'reselect';
import flatMapDeep from 'lodash/flatMapDeep';

import { getUser } from '@crm-framework/auth';

import { ICoreState } from '@crm-package/app';
import { getDictionaryByNameSelector } from '@crm-package/dictionaries';
import { USER_RIGHTS } from '@crm-package/auth';

import { getBusinessUnitsSortByNameHelper } from './selectorHelpers';

export const getBusinessUnitsSortByName = createSelector(
  (state: ICoreState) => getDictionaryByNameSelector(state, 'businessUnit'),
  (businessUnits) => getBusinessUnitsSortByNameHelper(businessUnits)
);

export const getBusinessUnitsAvailableForUser = createSelector(
  getBusinessUnitsSortByName,
  getUser,
  (businessUnits, user) => {
    if (user?.rights.includes(USER_RIGHTS.ALL)) {
      return businessUnits.filter((businessUnit) =>
        flatMapDeep(user.businessUnitRights).includes(businessUnit.id)
      );
    }

    return businessUnits;
  }
);
